import { render, staticRenderFns } from "./followChart.vue?vue&type=template&id=7424999b&scoped=true"
import script from "./followChart.vue?vue&type=script&lang=js"
export * from "./followChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7424999b",
  null
  
)

export default component.exports